import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { del, get, post, patch } from "../../api/api";

// Obtem info financeiras empresas
export const obtemInfoFinanceiras = async (empId: string, mesCompetencia?: string) => {
  const query = mesCompetencia ? `?mesCompetencia=${mesCompetencia}` : '';
  return await get<IRespostaFuncao<any[]>>(`/empresas/${empId}/info-financeiras${query}`);
};

// Criar info financeira
export const criarInfoFinanceira = async (
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/info-financeiras`,
    payload
  );
};

// Atualizar info financeira
export const atualizarInfoFinanceira = async (
  id: string,
  payload: any,
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/info-financeiras/${id}`,
    payload
  );
};

// Deletar info financeira
export const deletarInfoFinanceira = async (
  id: string,
): Promise<IRespostaFuncao<any>> => {
  return await del<IRespostaFuncao<any>>(
    `/info-financeiras/${id}`
  );
};

// Obtem DREs
export const obtemDres = async () => {
  return await get<IRespostaFuncao<any[]>>(`/dres`);
};
